export class OutpostStatus {
  constructor(
    public id: number,
    public isOnline: boolean,
    public lastSeenUtc: Date,
  ) {}
}
